import React, { useState, useEffect } from "react";
import TestimonialSlider from './TestimonialSlider';
import HomePageContent from "./HomePageContent";
import HomePageSlider from './HomePageSlider';
import LetUsTalk from "./LetUsTalk";
import WelcomeScreen from "./WelcomeScreen";  // ✅ import
import { Helmet } from "react-helmet-async";

import './App.css';

function App() {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("welcomeShown");

    if (!alreadyShown) {
      setShowWelcome(true);
      sessionStorage.setItem("welcomeShown", "true"); // ✅ sirf first time
    }
  }, []);

  if (showWelcome) {
    return <WelcomeScreen onFinish={() => setShowWelcome(false)} />;
  }

  return (




    

    <div>
<Helmet>
  <title>Home Page | APTech Solution - Web, App & Software Development Digital Marketing Ankleshwar</title>
  <meta
    name="description"
    content="APTech Solution offers web development, mobile app (iOS & Android), Salesforce development, custom software, digital marketing, and maintenance services in Ankleshwar, Gujarat, India."
  />


   <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "APTech Solution",
            "url": "https://aptechsolution.com",
            "logo": "https://aptechsolution.com/logo.png",
            "sameAs": [
              "https://www.facebook.com/aptechsolution",
              "https://www.linkedin.com/company/aptechsolution"
            ]
          }
          `}
        </script>
</Helmet>

   
      {/* <HomePageSlider /> */}
      <HomePageContent />
      <LetUsTalk />
      <TestimonialSlider />
    </div>
    
  
  );
}

export default App;
